module.exports = __webpack_public_path__ + "static/learn-ff17256ded4a3bf0df8513ab64d255e3.mp4";